import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconReceptionist: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 5a2 2 0 11-4 0 2 2 0 014 0zm-2 2c-5 0-9 4-9 9 0 .6.4 1 1 1h16c.6 0 1-.4 1-1 0-5-4-9-9-9zm6.9 8c-.5-3.4-3.4-6-6.9-6-3.5 0-6.4 2.6-6.9 6h13.8zM4 19c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.4-1-1-1H4zm9-8.1c.3-.5.9-.7 1.4-.4.9.5 1.7 1.1 2.5 1.9.4.4.3 1-.1 1.4-.2.1-.5.2-.7.2-.3 0-.6-.1-.8-.3-.6-.6-1.2-1.1-1.9-1.5-.5-.2-.7-.9-.4-1.3z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
